<script setup>
defineProps(['companyLogo']);
</script>

<template>
  <img :src="companyLogo" alt="Company Logo">
</template>
